'use client';
const MANIFEST_ILLUSTRATIONS = {
    success: {
        hashed: 'success.b3e20e5c148826dc9c9aef81886b2551.png',
        versioned: 'success.png'
    },
    search: {
        hashed: 'search.e0a29535f6c39b8c36a0443916bab4d7.png',
        versioned: 'search.png'
    },
    orders: {
        hashed: 'orders.9949a658b5d5c622d79e64d8d9c9ef3d.png',
        versioned: 'orders.png'
    },
    myProjects: {
        hashed: 'myProjects.53c5cf35f0558e75bfd196639c74d28d.png',
        versioned: 'myProjects.png'
    },
    liveChat: {
        hashed: 'liveChat.208e20d88182705d838d1a63131534b8.png',
        versioned: 'liveChat.png'
    },
    generic: {
        hashed: 'generic.f7bb7d8c61ea6b096d6bc42c4c773a95.png',
        versioned: 'generic.png'
    },
    error: {
        hashed: 'error.0905d81c1fcac74b226be7f452e700d5.png',
        versioned: 'error.png'
    },
    designServices: {
        hashed: 'designServices.c34d0bb4b567ff8902a4f752e9a1b42a.png',
        versioned: 'designServices.png'
    },
    cart: {
        hashed: 'cart.18615cc74704cae1de302cffb567c881.png',
        versioned: 'cart.png'
    },
    brief: {
        hashed: 'brief.6daa55f571692bd8d143ddac3f96f747.png',
        versioned: 'brief.png'
    }
};

export { MANIFEST_ILLUSTRATIONS };
